// extracted by mini-css-extract-plugin
module.exports = {"title":"Login_title__nnsE-","content":"Login_content__2R4Bm","formWrapper":"Login_formWrapper__1vHap"};